@use "../../../styles/Colors.scss" as Colors;
@use "../../../styles/Constants.scss" as Constants;

$var-dropdown-height: 400px;
$var-dropdown-width: 300px;
$var-search-height: 32px;
$var-dropdown-item-height: 32px;
$var-toggle-width: 100px;
$var-tags-height: 280px;
$var-text-multiple-dropdown-height: 290px;
$var-shadow: 0 1px 4px 0 Colors.$col-shadow;

.container {
	display: grid !important;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(10, 1fr);
	max-height: $var-dropdown-height;
}

.search-input-container {
	padding-right: 0 !important;
	padding-left: Constants.$val-spacing-s !important;
	position: relative;
	background-color: Colors.$col-white;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	position: sticky;
	top: 0;
	z-index: 1;

	& > input {
		height: $var-search-height;
	}

	& > [class^="icon-"] {
		position: absolute;
		right: Constants.$val-spacing-l;
		cursor: pointer;
		color: Colors.$col-greyFontLight;
		display: flex;
		align-items: center;
		font-size: Constants.$val-fontSizeBig;

		&:hover,
		&:active,
		&:focus {
			color: Colors.$col-greyDark;
		}
	}

	& > [class^="icon-search"] {
		cursor: initial;
	}

	&:hover {
		background-color: Colors.$col-white !important;
	}
}

.search-input {
	border: 1px solid #c1c7cc;
	border-radius: 2px;
	flex: 1;
	font-size: 14px;
	line-height: 16px;
	outline: none;
}

.primary-options {
	width: $var-dropdown-width;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	overflow-y: auto;
	grid-area: 1 / 1 / 10 / 2;

	& > :global(.dropdown-item) {
		height: auto !important;
	}

	&__header {
		position: relative;
		background-color: Colors.$col-white;
		display: flex;
		flex-direction: column;
		position: sticky;
		top: 0;
		z-index: 1;
	}
	&__name {
		position: sticky;
		top: 0;
		text-transform: uppercase;
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-design-grey10;
		padding: 0 Constants.$val-spacing-m;
	}

	&__item {
		display: flex;
		max-width: $var-dropdown-width;

		&--selected {
			background-color: Colors.$col-orangeHover;
		}

		&__label {
			flex: 1;
			white-space: normal;
		}

		& > [class^="icon-right"] {
			font-size: Constants.$val-fontSizeXBig;
			color: Colors.$col-design-grey500;
		}
	}

	&__no-results {
		height: $var-dropdown-item-height !important;
	}
}

.selected {
	border: 1px solid #c1c7cc !important;
	width: 100%;
	padding: 0 8px;
	min-height: 30px;
	min-width: $var-toggle-width;
	height: fit-content;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	background-color: Colors.$col-white;
	color: Colors.$col-greyDark;

	&__placeholder {
		color: Colors.$col-greyFontLight;
		flex: 1;
		text-align: start;
	}

	&__label {
		flex: 1;
	}

	&__icons {
		display: flex;
		align-items: center;

		& > [class^="icon-down"] {
			color: Colors.$col-greyDark;
		}

		& > [class^="icon-close"] {
			color: Colors.$col-greyFontLight;
			cursor: pointer;

			&:hover {
				color: Colors.$col-greyDark;
			}
		}
	}
}

.toggle {
	padding: 0;
}

.secondary-options {
	width: $var-dropdown-width;
	grid-area: 1 / 2 / 10 / 3;

	&__name {
		text-transform: uppercase;
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-design-grey10;
		padding: Constants.$val-spacing-xs Constants.$val-spacing-m;
	}
}

.text-secondary {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-m;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	height: 300px;
	overflow: auto;

	&__search-input-wrapper {
		position: relative;

		& > [class^="icon-down"] {
			right: Constants.$val-spacing-m;
			position: absolute;
			bottom: Constants.$val-spacing-s;
		}

		& > input[readonly] {
			background-color: Colors.$col-white;
			cursor: pointer;
		}
	}

	&__dropdown {
		background-color: Colors.$col-white;
		box-shadow: $var-shadow;
		border: 1px solid Colors.$col-lighterGrey;
		border-radius: Constants.$val-borderRadius;
		position: fixed;
		margin-top: calc(Constants.$val-spacing-xs / 2);
		width: 100%;
		max-width: $var-dropdown-width - 2 * Constants.$val-spacing-s; // two times padding
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-s;
		max-height: $var-text-multiple-dropdown-height;
		overflow: auto;

		&__item {
			display: flex;
			padding: Constants.$val-spacing-s;

			&__label {
				flex: 1;

				&--empty {
					color: Colors.$col-blue;
				}
			}

			&:hover {
				background-color: Colors.$col-design-orange5 !important;
			}
		}
	}

	&__single-tag {
		display: flex;
		width: 100%;

		&__option {
			flex: 1;

			&--empty {
				color: Colors.$col-blue;
			}
		}
	}

	&__tags {
		max-width: $var-dropdown-width;
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-xs;
	}
}
.apply-button {
	grid-area: 10 / 1 / 11 / 3;
	display: flex;
	justify-content: center;
	padding-top: Constants.$val-spacing-s;

	& > button {
		width: 66%;
		display: flex;
		justify-content: center;
	}
}

.dropdown-secondary {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-xs;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;

	&__dropdown {
		width: 100%;
	}

	&__menu-item {
		display: flex;
		width: 100%;

		&__label {
			flex: 1;
		}
	}
	&__single-tag {
		display: flex;
		width: 100%;

		&__option {
			flex: 1;

			&--empty {
				color: Colors.$col-blue;
			}
		}
	}

	&__tags {
		max-width: $var-dropdown-width;
		max-height: $var-tags-height;
		padding: Constants.$val-spacing-s;
		overflow: auto;
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-xs;
	}
}
